// extracted by css-extract-rspack-plugin
export default {"Text":"AuthorDisplayName-module__Text__OP5Q9","truncate":"AuthorDisplayName-module__truncate__d1MRu"};